import React from 'react';
import PropTypes from 'prop-types';
import contentTypeName, { contentTypePlural } from '../../utils/contentTypeName';
import Button from '../Global/Buttons/Button';

const SearchTypeTopResults = ({ filter, onViewAllClick, children }) => {
  const filterName = contentTypePlural(contentTypeName(filter.itemName));

  return (
    <div className="search-type-top-results m-b-3">
      <div className={`border-bottom-1 border-color-grey--light p-b-3 m-b-3 d-flex justify-content-space-between fw-medium color-${filter.itemName}`}>
        <h2 className="like-h5 m-b-0 text-capitalize">{filterName}</h2>
        <Button 
          onClick={() => onViewAllClick(contentTypeName(filter.itemName))}
          classes="like-h5 link m-b-0" 
          faux
        >
          View all
        </Button>
      </div>
      {children}
    </div>
  );
};

SearchTypeTopResults.propTypes = {
  filter: PropTypes.object.isRequired,
  onViewAllClick: PropTypes.func.isRequired,
  children: PropTypes.object,
};

export default SearchTypeTopResults;



// WEBPACK FOOTER //
// ./library/app/components/Search/SearchTypeTopResults.js